import { Divider, Heading, Text } from '@chakra-ui/react'
import type { AuctionWithHighestBid } from '@twlvxtwlv/supabase'
import { getProductAvailability } from '@twlvxtwlv/tokenforge'
import type { NotifyMeAttributes, ProductAvailability, RoadmapEntry } from '@twlvxtwlv/types'
import type { ProductPurchasbility } from '@twlvxtwlv/types'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { AuctionCta } from '../../cta/auction-cta'
import { RoadmapProductsLeftCta } from '../../cta/roadmap-products-left-cta'

interface RoadmapListItemContentProps {
  auctionsWithHighestBid: AuctionWithHighestBid[]
  roadmapItem: RoadmapEntry
  displayDate: string | null
  availability: ProductAvailability | null | undefined
  onOpenNotifyMeModal: () => void
  onNotifyMeAttributesChanged: (attributes: NotifyMeAttributes | null) => void
}

export function RoadmapListItemContent({
  auctionsWithHighestBid,
  roadmapItem,
  displayDate,
  availability,
  onOpenNotifyMeModal,
  onNotifyMeAttributesChanged,
}: RoadmapListItemContentProps) {
  const { t } = useTranslation('nft-details')

  const [productPurchasbility, setProductPurchasbility] = useState<ProductPurchasbility | null>(
    null
  )

  const { currentlyActive, currentlyAvailableTokens, headline, nftId, priceInEuros, subHeadline } =
    roadmapItem

  const auctionWithHighestBid: AuctionWithHighestBid | undefined = auctionsWithHighestBid?.find(
    (auction) => {
      return auction.tfProductId === nftId
    }
  )

  useEffect(() => {
    if (!roadmapItem) return
    setProductPurchasbility(getProductAvailability(roadmapItem, currentlyAvailableTokens ?? 0))
  }, [])

  return (
    <>
      <Heading fontSize="xs" fontWeight="400" color="txtWhite" textTransform="uppercase" pb={2}>
        {currentlyActive ? t('road-map-currently-ongoing') : displayDate}
      </Heading>
      <Text fontWeight="600" fontSize={['sm', 'sm', 'md']} textTransform="uppercase">
        {headline}
      </Text>
      <Text fontSize="sm">{subHeadline}</Text>

      {priceInEuros && productPurchasbility?.isListable ? (
        <>
          <Divider size="md" orientation="horizontal" borderColor="txtLightGray" w="full" />
          {auctionWithHighestBid ? (
            <AuctionCta color="white" auctionWithHighestBid={auctionWithHighestBid} />
          ) : (
            <RoadmapProductsLeftCta
              currentlyAvailableTokens={currentlyAvailableTokens}
              productIsPurchasable={productPurchasbility.isPurchasable}
              nftId={roadmapItem?.nftId ?? 'MISSING ID'}
              priceInEuroCents={priceInEuros}
              showTokensLeft={roadmapItem.productType !== 'ticket'}
              availability={availability}
              onOpenNotifyMeModal={onOpenNotifyMeModal}
              onNotifyMeAttributesChanged={onNotifyMeAttributesChanged}
              nftTitle={roadmapItem?.headline ?? 'MISSING TITLE'}
            />
          )}
        </>
      ) : null}
    </>
  )
}
